import LoadingShield from './LoadingShield';

export default LoadingShield;
